import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import $ from 'jquery';
import CyberSecurity from '../apis/cyberSecurityData';

class ImageUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
        }
    }

    singleFileChangedHandler = (event) => {

        let data = new FormData();
        if (event.target.files[0]) {
            data.append('profileImage', event.target.files[0], event.target.files[0].name);
            CyberSecurity.post('/img-upload', data, {
                headers: {
                    'accept': 'application/json',
                    'Accept-Language': 'en-US,en;q=0.8',
                    'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
                    Authorization: 'Bearer ' + this.props.accessToken
                }
            })
                .then((response) => {
                    if (200 === response.status) {
                        // If file size is larger than expected.
                        if (response.data.error) {
                            if ('LIMIT_FILE_SIZE' === response.data.error.code) {
                                this.ocShowAlert('Max size: 1MB', 'red');
                            } else {
                                // If not the given file type
                                this.ocShowAlert(response.data.error, 'red');
                            }
                        } else {
                            // Success
                            let fileName = response.data;
                            console.log(response.data.location)
                            this.setState({ image: response.data.location })
                            this.props.onImageUploadClick(response.data.location)
                            this.ocShowAlert('File Uploaded', '#3089cf');
                        }
                    }
                }).catch((error) => {
                    console.log(error)
                    // If another error
                    this.ocShowAlert(error, 'red');
                });
        } else {
            // if file not selected throw error
            this.ocShowAlert('Please upload file', 'red');
        }
    };

    // ShowAlert Function
    ocShowAlert = (message, background = '#3089cf') => {
        let alertContainer = document.querySelector(`#${this.props.alertContainer}`),
            alertEl = document.createElement('div'),
            textNode = document.createTextNode(message);
        alertEl.setAttribute('class', this.props.alertContainer);
        $(alertEl).css('background', background);
        alertEl.appendChild(textNode);
        alertContainer.appendChild(alertEl);
        setTimeout(function () {
            $(alertEl).fadeOut('slow');
            $(alertEl).remove();
        }, 3000);
    };

    render() {
        return (
            <div className="img-upload-inner" >
                <input type="file" onChange={this.singleFileChangedHandler} ref={fileInput => this.fileInput = fileInput} style={{ display: 'none' }} />
                <Button variant="link" size="sm" onClick={() => this.fileInput.click()}><i className="material-icons">
                    edit
                </i></Button>
                <div id={this.props.alertContainer}></div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        accessToken: state.accessToken,
    }
}

export default connect(mapStateToProps)(ImageUpload);
